import { DisplayWidth } from '../types/api/ApiFormField';

export const displayWidthToGrid: { [key in DisplayWidth]: number } = {
  full: 12,
  half: 6,
  third: 4,
  quarter: 3,
};
